import { createRouter, createWebHistory } from 'vue-router'

const router = createRouter({
    history: createWebHistory(),
    routes: [
        {
            path: '/',
            name: "DailyBus - Twój partner w podróży",
            component: () => import('@/views/MainPage.vue'),
        },
        {
            path: '/rezerwacja-pojazdu',
            name: "Formularz rezerwacji - Dailybus",
            component: () => import('@/views/ReservationCar.vue'),
        },
        {
            path: '/potwierdzenie-rezerwacji',
            name: "Potwierdzenie rezerwacji - DailyBus",
            component: () => import('@/views/ConfirmReservation.vue'),
        },
        {
            path: '/warunki-korzystania',
            name: "Regulamin - Dailybus",
            component: () => import('@/views/Regulations.vue'),
        },
        {
            path: '/polityka-prywatnosci',
            name: "Polityka Prywatności - DailyBus",
            component: () => import('@/views/PrivatePolicy.vue'),
        },
        // main page
        {
            path: '/kroki',
            name: "Kroki DailyBus - Twój partner w podróży",
            component: () => import('@/views/MainPage.vue'),
            meta: { scrollTo: 'kroki' }
        },
        {
            path: '/cennik',
            name: "Cennik DailyBus - Twój partner w podróży",
            component: () => import('@/views/MainPage.vue'),
            meta: { scrollTo: 'cennik' }
        },
        {
            path: '/pojazd',
            name: "Flota DailyBus - Twój partner w podróży",
            component: () => import('@/views/MainPage.vue'),
            meta: { scrollTo: 'pojazd' }
        },
        {
            path: '/galeria',
            name: "Galeria DailyBus - Twój partner w podróży",
            component: () => import('@/views/MainPage.vue'),
            meta: { scrollTo: 'galeria' }
        },
        {
            path: '/jak-zarezerwowac-busa',
            name: "Rezerwacja DailyBus - Twój partner w podróży",
            component: () => import('@/views/MainPage.vue'),
            meta: { scrollTo: 'kroki' }
        }, {
            path: '/oferta',
            name: "Oferta DailyBus - Twój partner w podróży",
            component: () => import('@/views/MainPage.vue'),
            meta: { scrollTo: 'oferta' }
        },
        {
            path: '/opinie',
            name: "Opinie DailyBus - Twój partner w podróży",
            component: () => import('@/views/MainPage.vue'),
            meta: { scrollTo: 'opinie' }
        },
        {
            path: '/dlaczego-dailybus',
            name: "Dlaczego DailyBus - Twój partner w podróży",
            component: () => import('@/views/MainPage.vue'),
            meta: { scrollTo: 'dlaczego-dailybus' }
        },
        {
            path: '/kontakt',
            name: "Kontakt DailyBus - Twój partner w podróży",
            component: () => import('@/views/Contact.vue'),
            meta: { scrollTo: 'contact-section' }
        }
    ],
    scrollBehavior(to) {
        if (to.meta.scrollTo) {
            return {
                el: `#${to.meta.scrollTo}`,
                behavior: 'auto',
                top: 20,
            }
        }
    }
})

router.beforeEach((to) => {
    document.title = to.name ?? 'Default Title'
});

export default router